import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelDynamic as _vModelDynamic, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f3fbc1c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "register-page" }
const _hoisted_2 = { class: "register-container" }
const _hoisted_3 = { class: "register-card" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"register-header\" data-v-f3fbc1c6><div class=\"logo-section\" data-v-f3fbc1c6><div class=\"logo-icon\" data-v-f3fbc1c6><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-f3fbc1c6><path d=\"M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5\" data-v-f3fbc1c6></path></svg></div><h1 data-v-f3fbc1c6>Create Account</h1><p data-v-f3fbc1c6>Join our learning community today</p></div></div>", 1)
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "full_name" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "12",
      cy: "7",
      r: "4"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" Full Name - (الاسم الكامل) ")
], -1 /* HOISTED */))
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "error-message"
}
const _hoisted_9 = {
  key: 1,
  class: "success-icon"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" }),
    /*#__PURE__*/_createElementVNode("polyline", { points: "22,6 12,13 2,6" })
  ]),
  /*#__PURE__*/_createTextVNode(" Email Address - (البريد الإلكتروني) ")
], -1 /* HOISTED */))
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "error-message"
}
const _hoisted_13 = {
  key: 1,
  class: "success-icon"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "phone" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" })
  ]),
  /*#__PURE__*/_createTextVNode(" Phone Number - (رقم الهاتف) ")
], -1 /* HOISTED */))
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "error-message"
}
const _hoisted_17 = {
  key: 1,
  class: "success-icon"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      x: "3",
      y: "11",
      width: "18",
      height: "11",
      rx: "2",
      ry: "2"
    }),
    /*#__PURE__*/_createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
  ]),
  /*#__PURE__*/_createTextVNode(" Password - (كلمة المرور) ")
], -1 /* HOISTED */))
const _hoisted_19 = { class: "password-input-wrapper" }
const _hoisted_20 = ["type", "disabled"]
const _hoisted_21 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }, null, -1 /* HOISTED */))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "3"
}, null, -1 /* HOISTED */))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" }, null, -1 /* HOISTED */))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "1",
  y1: "1",
  x2: "23",
  y2: "23"
}, null, -1 /* HOISTED */))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = {
  key: 0,
  class: "password-strength"
}
const _hoisted_30 = { class: "strength-bar" }
const _hoisted_31 = {
  key: 1,
  class: "error-message"
}
const _hoisted_32 = {
  key: 2,
  class: "success-icon"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "confirm_password" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      x: "3",
      y: "11",
      width: "18",
      height: "11",
      rx: "2",
      ry: "2"
    }),
    /*#__PURE__*/_createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
  ]),
  /*#__PURE__*/_createTextVNode(" Confirm Password - (تأكيد كلمة المرور) ")
], -1 /* HOISTED */))
const _hoisted_34 = { class: "password-input-wrapper" }
const _hoisted_35 = ["type", "disabled"]
const _hoisted_36 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }, null, -1 /* HOISTED */))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "3"
}, null, -1 /* HOISTED */))
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" }, null, -1 /* HOISTED */))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "1",
  y1: "1",
  x2: "23",
  y2: "23"
}, null, -1 /* HOISTED */))
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = {
  key: 0,
  class: "error-message"
}
const _hoisted_45 = {
  key: 1,
  class: "success-icon"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "address_line1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" }),
    /*#__PURE__*/_createElementVNode("polyline", { points: "9 22 9 12 15 12 15 22" })
  ]),
  /*#__PURE__*/_createTextVNode(" Street Address - (العنوان) ")
], -1 /* HOISTED */))
const _hoisted_47 = ["disabled"]
const _hoisted_48 = {
  key: 0,
  class: "error-message"
}
const _hoisted_49 = {
  key: 1,
  class: "success-icon"
}
const _hoisted_50 = { class: "form-row" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "city" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "12",
      cy: "10",
      r: "3"
    }),
    /*#__PURE__*/_createElementVNode("path", { d: "M12 2a8 8 0 0 0-8 8c0 5.25 8 14 8 14s8-8.75 8-14a8 8 0 0 0-8-8z" })
  ]),
  /*#__PURE__*/_createTextVNode(" City - (المدينة) ")
], -1 /* HOISTED */))
const _hoisted_52 = ["disabled"]
const _hoisted_53 = {
  key: 0,
  class: "error-message"
}
const _hoisted_54 = {
  key: 1,
  class: "success-icon"
}
const _hoisted_55 = /*#__PURE__*/_createStaticVNode("<label for=\"country\" data-v-f3fbc1c6><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-f3fbc1c6><circle cx=\"12\" cy=\"12\" r=\"10\" data-v-f3fbc1c6></circle><line x1=\"2\" y1=\"12\" x2=\"22\" y2=\"12\" data-v-f3fbc1c6></line><path d=\"M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z\" data-v-f3fbc1c6></path></svg> Country - (الدولة) </label>", 1)
const _hoisted_56 = ["disabled"]
const _hoisted_57 = {
  key: 0,
  class: "error-message"
}
const _hoisted_58 = {
  key: 1,
  class: "success-icon"
}
const _hoisted_59 = ["disabled"]
const _hoisted_60 = {
  key: 0,
  class: "spinner"
}
const _hoisted_61 = { key: 1 }
const _hoisted_62 = { class: "register-footer" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-icon" }, "🎉", -1 /* HOISTED */))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Welcome Aboard!", -1 /* HOISTED */))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Your account has been created successfully. Please check your email to verify your account.", -1 /* HOISTED */))
const _hoisted_67 = ["onClick"]
const _hoisted_68 = { class: "modal-content error-modal" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-icon" }, "⚠️", -1 /* HOISTED */))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Registration Failed", -1 /* HOISTED */))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createCommentVNode(" Header "),
        _hoisted_4,
        _createCommentVNode(" Form "),
        _createElementVNode("form", {
          onSubmit: _withModifiers($setup.handleSubmit, ["prevent"]),
          class: "register-form"
        }, [
          _createCommentVNode(" Full Name "),
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", { 'has-error': $setup.errors.full_name, 'has-success': $setup.touched.full_name && !$setup.errors.full_name && $setup.form.full_name }])
          }, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "full_name",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.form.full_name) = $event)),
              onBlur: _cache[1] || (_cache[1] = $event => ($setup.validateField('full_name'))),
              placeholder: "Enter your full name",
              disabled: $setup.loading
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_7), [
              [_vModelText, $setup.form.full_name]
            ]),
            ($setup.errors.full_name)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($setup.errors.full_name), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            ($setup.touched.full_name && !$setup.errors.full_name && $setup.form.full_name)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "✓"))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */),
          _createCommentVNode(" Email "),
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", { 'has-error': $setup.errors.email, 'has-success': $setup.touched.email && !$setup.errors.email && $setup.form.email }])
          }, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              type: "email",
              id: "email",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.form.email) = $event)),
              onBlur: _cache[3] || (_cache[3] = $event => ($setup.validateField('email'))),
              placeholder: "you@example.com",
              disabled: $setup.loading
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_11), [
              [_vModelText, $setup.form.email]
            ]),
            ($setup.errors.email)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString($setup.errors.email), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            ($setup.touched.email && !$setup.errors.email && $setup.form.email)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, "✓"))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */),
          _createCommentVNode(" Phone "),
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", { 'has-error': $setup.errors.phone, 'has-success': $setup.touched.phone && !$setup.errors.phone && $setup.form.phone }])
          }, [
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              type: "tel",
              id: "phone",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.form.phone) = $event)),
              onBlur: _cache[5] || (_cache[5] = $event => ($setup.validateField('phone'))),
              placeholder: "+1 (555) 123-4567",
              disabled: $setup.loading
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_15), [
              [_vModelText, $setup.form.phone]
            ]),
            ($setup.errors.phone)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString($setup.errors.phone), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            ($setup.touched.phone && !$setup.errors.phone && $setup.form.phone)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, "✓"))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */),
          _createCommentVNode(" Password "),
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", { 'has-error': $setup.errors.password, 'has-success': $setup.touched.password && !$setup.errors.password && $setup.form.password }])
          }, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _withDirectives(_createElementVNode("input", {
                type: $setup.showPassword ? 'text' : 'password',
                id: "password",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.form.password) = $event)),
                onBlur: _cache[7] || (_cache[7] = $event => ($setup.validateField('password'))),
                onInput: $setup.checkPasswordStrength,
                placeholder: "Create a strong password",
                disabled: $setup.loading
              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_20), [
                [_vModelDynamic, $setup.form.password]
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "toggle-password",
                onClick: _cache[8] || (_cache[8] = $event => ($setup.showPassword = !$setup.showPassword)),
                tabindex: "-1"
              }, [
                (!$setup.showPassword)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_21, _hoisted_24))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_25, _hoisted_28))
              ])
            ]),
            _createCommentVNode(" Password Strength Indicator "),
            ($setup.form.password)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", {
                      class: _normalizeClass(['strength-fill', $setup.passwordStrengthClass]),
                      style: _normalizeStyle({ width: $setup.passwordStrength + '%' })
                    }, null, 6 /* CLASS, STYLE */)
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass(['strength-text', $setup.passwordStrengthClass])
                  }, _toDisplayString($setup.passwordStrengthText), 3 /* TEXT, CLASS */)
                ]))
              : _createCommentVNode("v-if", true),
            ($setup.errors.password)
              ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString($setup.errors.password), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            ($setup.touched.password && !$setup.errors.password && $setup.form.password)
              ? (_openBlock(), _createElementBlock("span", _hoisted_32, "✓"))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */),
          _createCommentVNode(" Confirm Password "),
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", { 'has-error': $setup.errors.confirm_password, 'has-success': $setup.touched.confirm_password && !$setup.errors.confirm_password && $setup.form.confirm_password }])
          }, [
            _hoisted_33,
            _createElementVNode("div", _hoisted_34, [
              _withDirectives(_createElementVNode("input", {
                type: $setup.showConfirmPassword ? 'text' : 'password',
                id: "confirm_password",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($setup.form.confirm_password) = $event)),
                onBlur: _cache[10] || (_cache[10] = $event => ($setup.validateField('confirm_password'))),
                placeholder: "Confirm your password",
                disabled: $setup.loading
              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_35), [
                [_vModelDynamic, $setup.form.confirm_password]
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "toggle-password",
                onClick: _cache[11] || (_cache[11] = $event => ($setup.showConfirmPassword = !$setup.showConfirmPassword)),
                tabindex: "-1"
              }, [
                (!$setup.showConfirmPassword)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_36, _hoisted_39))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_40, _hoisted_43))
              ])
            ]),
            ($setup.errors.confirm_password)
              ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString($setup.errors.confirm_password), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            ($setup.touched.confirm_password && !$setup.errors.confirm_password && $setup.form.confirm_password)
              ? (_openBlock(), _createElementBlock("span", _hoisted_45, "✓"))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */),
          _createCommentVNode(" Address "),
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", { 'has-error': $setup.errors.address_line1, 'has-success': $setup.touched.address_line1 && !$setup.errors.address_line1 && $setup.form.address_line1 }])
          }, [
            _hoisted_46,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "address_line1",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (($setup.form.address_line1) = $event)),
              onBlur: _cache[13] || (_cache[13] = $event => ($setup.validateField('address_line1'))),
              placeholder: "123 Main St",
              disabled: $setup.loading
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_47), [
              [_vModelText, $setup.form.address_line1]
            ]),
            ($setup.errors.address_line1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString($setup.errors.address_line1), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            ($setup.touched.address_line1 && !$setup.errors.address_line1 && $setup.form.address_line1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_49, "✓"))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", {
              class: _normalizeClass(["form-group", { 'has-error': $setup.errors.city, 'has-success': $setup.touched.city && !$setup.errors.city && $setup.form.city }])
            }, [
              _hoisted_51,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "city",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (($setup.form.city) = $event)),
                onBlur: _cache[15] || (_cache[15] = $event => ($setup.validateField('city'))),
                placeholder: "Cairo",
                disabled: $setup.loading
              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_52), [
                [_vModelText, $setup.form.city]
              ]),
              ($setup.errors.city)
                ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString($setup.errors.city), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              ($setup.touched.city && !$setup.errors.city && $setup.form.city)
                ? (_openBlock(), _createElementBlock("span", _hoisted_54, "✓"))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */),
            _createElementVNode("div", {
              class: _normalizeClass(["form-group", { 'has-error': $setup.errors.country, 'has-success': $setup.touched.country && !$setup.errors.country && $setup.form.country }])
            }, [
              _hoisted_55,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "country",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => (($setup.form.country) = $event)),
                onBlur: _cache[17] || (_cache[17] = $event => ($setup.validateField('country'))),
                placeholder: "Egypt",
                disabled: $setup.loading
              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_56), [
                [_vModelText, $setup.form.country]
              ]),
              ($setup.errors.country)
                ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString($setup.errors.country), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              ($setup.touched.country && !$setup.errors.country && $setup.form.country)
                ? (_openBlock(), _createElementBlock("span", _hoisted_58, "✓"))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */)
          ]),
          _createCommentVNode(" Submit Button "),
          _createElementVNode("button", {
            type: "submit",
            class: "submit-btn",
            disabled: $setup.loading || !$setup.isFormValid
          }, [
            ($setup.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_60))
              : (_openBlock(), _createElementBlock("span", _hoisted_61, "Create Account"))
          ], 8 /* PROPS */, _hoisted_59)
        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_5),
        _createCommentVNode(" Footer "),
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("p", null, [
            _createTextVNode("Already have an account? "),
            _createVNode(_component_router_link, { to: { name: 'auth.login' } }, {
              default: _withCtx(() => [
                _createTextVNode("Sign in")
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to"])
          ])
        ])
      ]),
      _createCommentVNode(" Success Modal "),
      ($setup.showSuccessModal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal-overlay",
            onClick: _withModifiers($setup.closeModal, ["self"])
          }, [
            _createElementVNode("div", { class: "modal-content success-modal" }, [
              _hoisted_64,
              _hoisted_65,
              _hoisted_66,
              _createElementVNode("button", {
                onClick: $setup.goToLogin,
                class: "modal-btn"
              }, "Go to Login")
            ])
          ], 8 /* PROPS */, _hoisted_63))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Error Modal "),
      ($setup.showErrorModal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "modal-overlay",
            onClick: _withModifiers($setup.closeModal, ["self"])
          }, [
            _createElementVNode("div", _hoisted_68, [
              _hoisted_69,
              _hoisted_70,
              _createElementVNode("p", null, _toDisplayString($setup.errorMessage), 1 /* TEXT */),
              _createElementVNode("button", {
                onClick: $setup.closeModal,
                class: "modal-btn error"
              }, "Try Again")
            ])
          ], 8 /* PROPS */, _hoisted_67))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}